import { render, staticRenderFns } from "./RTXSwitch.vue?vue&type=template&id=3b14fe78&scoped=true&"
import script from "./RTXSwitch.vue?vue&type=script&lang=js&"
export * from "./RTXSwitch.vue?vue&type=script&lang=js&"
import style0 from "./RTXSwitch.vue?vue&type=style&index=0&id=3b14fe78&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b14fe78",
  null
  
)

export default component.exports